import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import * as api from '../../api';
import { supabase } from '../../lib/supabaseClient';
import Spinner from '../Atoms/Spinner';
import VoteModal from '../Components/VoteModal';

// ─── Constants ──────────────────────────────────────────────
const EVENT_ID = '67590da5499bcc995c210b40';

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a',
];

// ─── Styled Components ──────────────────────────────────────
const PageWrapper = styled.div`
    background: #fafbfc;
    min-height: 100vh;
    overflow-x: hidden;
`;

const TopBar = styled.div`
    background: white;
    border-bottom: 1px solid #e8e8e8;
    padding: 14px 20px;
`;

const TopBarInner = styled.div`
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const BackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: rgb(24, 51, 189);
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;

    &:hover { text-decoration: underline; }
`;

const LogoSmall = styled.img`
    height: 36px;
`;

const Container = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
`;

const ProjectSection = styled.div`
    padding: 40px 0;
`;

const ImageContainer = styled.div`
    border-radius: 16px;
    overflow: hidden;
    background: #f0f0f0;
    border: 1px solid #e0e0e0;
`;

const HeroImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
    max-height: 560px;
    object-fit: contain;
`;

const ImagePlaceholder = styled.div`
    width: 100%;
    height: 360px;
    background: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 16px;
`;

const GalleryRow = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 10px;
    overflow-x: auto;
    padding-bottom: 4px;
`;

const GalleryThumb = styled.div`
    width: 72px;
    height: 72px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-color: #eee;
    flex-shrink: 0;
    cursor: pointer;
    border: 2.5px solid ${props => props.active ? 'rgb(24, 51, 189)' : 'transparent'};
    transition: border-color 0.2s;
    opacity: ${props => props.active ? 1 : 0.7};

    &:hover {
        border-color: rgb(24, 51, 189);
        opacity: 1;
    }
`;

const InfoPanel = styled.div`
    background: white;
    border-radius: 16px;
    padding: 32px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    margin-top: 24px;

    @media (max-width: 768px) {
        padding: 24px;
    }
`;

const InfoTopRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        flex-direction: column;
    }
`;

const InfoLeft = styled.div`
    flex: 1;
    min-width: 0;
`;

const InfoRight = styled.div`
    flex-shrink: 0;
    width: 220px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (max-width: 600px) {
        width: 100%;
    }
`;

const TypeTag = styled.span`
    display: inline-block;
    padding: 5px 14px;
    border-radius: 100px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: ${props => props.type === 'objet'
        ? 'rgba(24, 51, 189, 0.1)'
        : 'rgba(0, 137, 123, 0.1)'};
    color: ${props => props.type === 'objet'
        ? 'rgb(24, 51, 189)'
        : 'rgb(0, 137, 123)'};
    margin-bottom: 16px;
`;

const ProjectTitle = styled.h1`
    font-size: 28px;
    font-weight: 800;
    color: #1a1a1a;
    margin: 0 0 8px 0;
    line-height: 1.3;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 22px;
    }
`;

const DesignerLabel = styled.p`
    font-size: 16px;
    color: #666;
    margin: 0 0 6px 0;
`;

const PartnerLabel = styled.p`
    font-size: 14px;
    color: #888;
    margin: 0 0 6px 0;
`;

const TypologyLabel = styled.p`
    font-size: 14px;
    color: #999;
    margin: 0 0 24px 0;
`;

const BigVoteButton = styled.button`
    width: 100%;
    padding: 16px;
    border: none;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s;
    background: ${props => props.voted
        ? 'linear-gradient(135deg, #28a745, #20c997)'
        : '#bbb'};
    color: white;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px ${props => props.voted
            ? 'rgba(40, 167, 69, 0.35)'
            : 'rgba(24, 51, 189, 0.4)'};
    }

    &:disabled {
        cursor: default;
    }
`;

const Divider = styled.hr`
    border: none;
    border-top: 1px solid #eee;
    margin: 20px 0;
`;

const ShareSection = styled.div``;

const ShareLabel = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
`;

const ShareButtons = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const ShareBtn = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    color: white;
    transition: transform 0.2s;

    &:hover {
        transform: translateY(-1px);
        color: white;
    }
`;

const CopyBtn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    border: 1.5px solid #ddd;
    background: white;
    color: #333;
    cursor: pointer;
    transition: all 0.2s;

    &:hover { border-color: #999; }
`;

// ─── Suggested projects section ─────────────────────────────
const SuggestedSection = styled.div`
    padding: 0 0 60px;
`;

const SectionTitle = styled.h2`
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 24px 0;
`;

const SuggestedGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 500px) {
        grid-template-columns: 1fr;
    }
`;

const SuggestedCard = styled(Link)`
    background: white;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    text-decoration: none;
    color: inherit;
    transition: all 0.25s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        border-color: #ccc;
    }
`;

const SuggestedImage = styled.div`
    width: 100%;
    height: 160px;
    background-size: cover;
    background-position: center;
    background-color: #f0f0f0;
`;

const SuggestedBody = styled.div`
    padding: 14px;
`;

const SuggestedDesigner = styled.p`
    font-size: 12px;
    color: #888;
    margin: 0;
`;

const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
`;

const NotFoundContainer = styled.div`
    text-align: center;
    padding: 80px 20px;
    color: #666;

    h2 { margin: 0 0 12px; }
    p { margin: 0 0 24px; }
`;

const BackButton = styled(Link)`
    display: inline-block;
    padding: 12px 28px;
    background: rgb(24, 51, 189);
    color: white;
    text-decoration: none;
    border-radius: 10px;
    font-weight: 600;

    &:hover { color: white; }
`;

const AllProjectsBtn = styled(Link)`
    display: block;
    width: fit-content;
    margin: 32px auto 0;
    padding: 14px 32px;
    background: linear-gradient(135deg, rgb(24, 51, 189), rgb(18, 38, 140));
    color: white;
    text-decoration: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 700;
    transition: all 0.25s;

    &, &:link, &:visited { color: white; }

    &:hover {
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(24, 51, 189, 0.35);
    }
`;

const SuggestedName = styled.h4`
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 4px 0;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
`;

// ─── Component ──────────────────────────────────────────────
const VoteFD100ProjectPage = () => {
    const { projectId } = useParams();
    const { i18n } = useTranslation('common');
    const isFr = i18n.language === 'fr';
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [definitiveNames, setDefinitiveNames] = useState({});
    const [projectsBasicData, setProjectsBasicData] = useState({});
    const [votedProjects, setVotedProjects] = useState(() =>
        JSON.parse(localStorage.getItem('fd100_voted_projects') || '[]')
    );
    const [voteModal, setVoteModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(0);
    const [copied, setCopied] = useState(false);
    const [partenaires, setPartenaires] = useState([]);

    // Capture UTM params (if user lands directly on a project page with UTM)
    useEffect(() => {
        const utmSource = searchParams.get('utm_source');
        if (utmSource) {
            const utm = {
                utm_source: utmSource,
                utm_medium: searchParams.get('utm_medium') || null,
                utm_campaign: searchParams.get('utm_campaign') || null,
                utm_content: searchParams.get('utm_content') || null,
            };
            sessionStorage.setItem('fd100_utm', JSON.stringify(utm));
        }
    }, [searchParams]);

    // Fetch all data in parallel: names + basic project data + partenaires
    useEffect(() => {
        Promise.all([
            supabase.from('fd100_project_names').select('*').eq('event_id', EVENT_ID),
            api.getProjectsBasicData({ projectIds: WINNER_PROJECT_IDS }),
            supabase.from('fd100_partenaires').select('name, type, linked_project_ids')
                .eq('event_id', EVENT_ID).in('type', ['fabricant', 'editeur']),
        ]).then(([namesRes, basicRes, partRes]) => {
            if (namesRes.data) {
                const map = {};
                namesRes.data.forEach(item => {
                    map[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                        typology_fr: item.typology_fr,
                        typology_en: item.typology_en,
                    };
                });
                setDefinitiveNames(map);
            }
            if (basicRes.data) setProjectsBasicData(basicRes.data);
            if (partRes.data) setPartenaires(partRes.data);
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    }, []);

    // Reset selected image when project changes
    useEffect(() => {
        setSelectedImage(0);
    }, [projectId]);

    // ─── Helpers ────────────────────────────────────────────
    const mediaBase = process.env.REACT_APP_MEDIA_BASE_URL + 'userfiles/';

    const getProjectName = (pid) => {
        const def = definitiveNames[pid];
        if (def) return isFr ? (def.name_fr || def.name_en || pid) : (def.name_en || def.name_fr || pid);
        return pid;
    };

    const getDesignerName = (pid) => {
        return definitiveNames[pid]?.designer || '';
    };

    const getTypology = (pid) => {
        const def = definitiveNames[pid];
        if (def) return isFr ? (def.typology_fr || '') : (def.typology_en || def.typology_fr || '');
        return '';
    };

    const getProjectType = (pid) => {
        return projectsBasicData[pid]?.type || 'objet';
    };

    const getProjectImage = (pid) => {
        const path = projectsBasicData[pid]?.imagePath;
        return path ? mediaBase + path : null;
    };

    // Check if current project is a valid winner
    const isValidProject = WINNER_PROJECT_IDS.includes(projectId);

    // Get partners for current project
    const projectPartners = useMemo(() => {
        if (!projectId || !partenaires.length) return { fabricants: [], editeurs: [] };
        return {
            fabricants: partenaires.filter(p => p.type === 'fabricant' && p.linked_project_ids?.includes(projectId)),
            editeurs: partenaires.filter(p => p.type === 'editeur' && p.linked_project_ids?.includes(projectId)),
        };
    }, [projectId, partenaires]);

    // Get project images (all images from basic data)
    const projectImages = useMemo(() => {
        const paths = projectsBasicData[projectId]?.imagePaths || [];
        return paths.map(p => mediaBase + p);
    }, [projectsBasicData, projectId]);

    // Suggested projects (same type, random 6, excluding current)
    const suggestedProjects = useMemo(() => {
        const currentType = getProjectType(projectId);
        const sameType = WINNER_PROJECT_IDS.filter(pid =>
            pid !== projectId && getProjectType(pid) === currentType
        );
        const shuffled = [...sameType].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, 6);
    }, [projectsBasicData, projectId]);

    const handleVoteSuccess = (pid) => {
        setVotedProjects(prev => [...prev, pid]);
    };

    const isVoted = votedProjects.includes(projectId);
    const projectUrl = `${window.location.origin}/vote/fd100/${projectId}`;

    const handleCopyLink = () => {
        navigator.clipboard.writeText(projectUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    if (loading) {
        return (
            <PageWrapper>
                <TopBar>
                    <TopBarInner>
                        <BackLink to="/vote/fd100">&#8592; {isFr ? 'Tous les projets' : 'All projects'}</BackLink>
                    </TopBarInner>
                </TopBar>
                <LoadingWrapper><Spinner /></LoadingWrapper>
            </PageWrapper>
        );
    }

    if (!isValidProject) {
        return (
            <PageWrapper>
                <TopBar>
                    <TopBarInner>
                        <BackLink to="/vote/fd100">&#8592; {isFr ? 'Tous les projets' : 'All projects'}</BackLink>
                    </TopBarInner>
                </TopBar>
                <NotFoundContainer>
                    <h2>{isFr ? 'Projet non trouvé' : 'Project not found'}</h2>
                    <p>{isFr ? 'Ce projet ne fait pas partie de la sélection Le FD100.' : 'This project is not part of the Le FD100 selection.'}</p>
                    <BackButton to="/vote/fd100">
                        {isFr ? 'Voir tous les projets' : 'View all projects'}
                    </BackButton>
                </NotFoundContainer>
            </PageWrapper>
        );
    }

    const projectName = getProjectName(projectId);
    const designerName = getDesignerName(projectId);
    const typology = getTypology(projectId);
    const projectType = getProjectType(projectId);

    const shareText = isFr
        ? `Votez pour "${projectName}" au Prix du Public Le FD100 !`
        : `Vote for "${projectName}" for the Le FD100 People's Choice Award!`;

    return (
        <PageWrapper>
            <TopBar>
                <TopBarInner>
                    <BackLink to="/vote/fd100">&#8592; {isFr ? 'Tous les projets' : 'All projects'}</BackLink>
                    <LogoSmall src="/assets/fd100-kit/logos/SD25-FD100-Logo-Story.png" alt="Le FD100" />
                </TopBarInner>
            </TopBar>

            <ProjectSection>
                <Container>
                    {/* Image gallery */}
                    <ImageContainer>
                        {projectImages.length > 0 ? (
                            <HeroImage src={projectImages[selectedImage] || projectImages[0]} alt={projectName} />
                        ) : (
                            <ImagePlaceholder>
                                {isFr ? 'Pas d\'image disponible' : 'No image available'}
                            </ImagePlaceholder>
                        )}
                    </ImageContainer>
                    {projectImages.length > 1 && (
                        <GalleryRow>
                            {projectImages.map((src, idx) => (
                                <GalleryThumb
                                    key={idx}
                                    active={idx === selectedImage}
                                    style={{ backgroundImage: `url(${src})` }}
                                    onClick={() => setSelectedImage(idx)}
                                />
                            ))}
                        </GalleryRow>
                    )}

                    {/* Info + Vote panel */}
                    <InfoPanel>
                        <InfoTopRow>
                            <InfoLeft>
                                <TypeTag type={projectType}>
                                    {projectType === 'objet'
                                        ? (isFr ? 'Objet' : 'Object')
                                        : (isFr ? 'Espace' : 'Space')}
                                </TypeTag>
                                <ProjectTitle>{projectName}</ProjectTitle>
                                <DesignerLabel>{designerName}</DesignerLabel>
                                {projectPartners.fabricants.length > 0 && (
                                    <PartnerLabel>
                                        {isFr ? 'Fabricant' : 'Manufacturer'}{projectPartners.fabricants.length > 1 ? 's' : ''} : {projectPartners.fabricants.map(p => p.name).join(', ')}
                                    </PartnerLabel>
                                )}
                                {projectPartners.editeurs.length > 0 && (
                                    <PartnerLabel>
                                        {isFr ? 'Éditeur' : 'Editor'}{projectPartners.editeurs.length > 1 ? 's' : ''} : {projectPartners.editeurs.map(p => p.name).join(', ')}
                                    </PartnerLabel>
                                )}
                                {typology && <TypologyLabel>{typology}</TypologyLabel>}
                            </InfoLeft>

                            <InfoRight>
                                <BigVoteButton
                                    voted={isVoted}
                                    disabled
                                >
                                    {isVoted
                                        ? (isFr ? 'Vote enregistré' : 'Vote recorded')
                                        : (isFr ? 'Votes clos' : 'Voting closed')}
                                </BigVoteButton>
                            </InfoRight>
                        </InfoTopRow>

                        <Divider />

                        <ShareSection>
                            <ShareLabel>{isFr ? 'Partager' : 'Share'}</ShareLabel>
                            <ShareButtons>
                                <ShareBtn
                                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(projectUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ background: '#0077B5' }}
                                >
                                    LinkedIn
                                </ShareBtn>
                                <ShareBtn
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(projectUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ background: '#1877F2' }}
                                >
                                    Facebook
                                </ShareBtn>
                                <CopyBtn onClick={handleCopyLink}>
                                    {copied
                                        ? (isFr ? 'Copié !' : 'Copied!')
                                        : (isFr ? 'Copier le lien' : 'Copy link')}
                                </CopyBtn>
                            </ShareButtons>
                        </ShareSection>
                    </InfoPanel>
                </Container>
            </ProjectSection>

            {/* Suggested Projects */}
            {suggestedProjects.length > 0 && (
                <SuggestedSection>
                    <Container>
                        <SectionTitle>
                            {isFr ? 'Découvrir d\'autres projets' : 'Discover more projects'}
                        </SectionTitle>
                        <SuggestedGrid>
                            {suggestedProjects.map(pid => (
                                <SuggestedCard key={pid} to={`/vote/fd100/${pid}`}>
                                    <SuggestedImage
                                        style={{ backgroundImage: getProjectImage(pid) ? `url(${getProjectImage(pid)})` : 'none' }}
                                    />
                                    <SuggestedBody>
                                        <SuggestedName>{getProjectName(pid)}</SuggestedName>
                                        <SuggestedDesigner>{getDesignerName(pid)}</SuggestedDesigner>
                                    </SuggestedBody>
                                </SuggestedCard>
                            ))}
                        </SuggestedGrid>
                        <AllProjectsBtn to="/vote/fd100">
                            {isFr ? 'Voir tous les projets' : 'See all projects'}
                        </AllProjectsBtn>
                    </Container>
                </SuggestedSection>
            )}

            {voteModal && (
                <VoteModal
                    projectId={projectId}
                    projectName={projectName}
                    projectImage={projectImages[0]}
                    designerName={designerName}
                    onClose={() => setVoteModal(false)}
                    onVoteSuccess={handleVoteSuccess}
                    utmParams={JSON.parse(sessionStorage.getItem('fd100_utm') || 'null')}
                />
            )}
        </PageWrapper>
    );
};

export default VoteFD100ProjectPage;
